import contentPathUrlMapper from '../src/utils/contentURLMapper';
import { fetchFeatureFlags } from '../src/utils/featureFlags';
import { useRenderAlerts } from '../src/utils/useRenderAlerts';

import ESI from '../src/components/ESI';
import logControl from '../src/utils/logger-utils/logControl';

function Content({ url, query, featureFlags }) {
  const path = query.path ? query.path : 'home';
  const { url: contentPath } = contentPathUrlMapper(url, false, featureFlags);

  useRenderAlerts('content-root-amp-content-renderer-homepage');

  return (
    <>
      <ESI src={contentPath} id={`content-renderer-${path}`} />
    </>
  );
}

export async function getServerSideProps(context) {
  const { resolvedUrl, query } = context;
  const featureFlags = fetchFeatureFlags(context);

  logControl(context);

  return {
    props: {
      url: resolvedUrl,
      query,
      featureFlags,
    },
  };
}

export default Content;
